let Page = 1; 
const limit = 3;

function loadBlogPosts(page) {
  fetch(`https://skoutshonor-a6ffe07477d4.herokuapp.com/api/blog-posts?page=${page}&limit=${limit}`)
    .then((response) => response.json())
    .then((data) => {
      console.log('Blog posts:', data);
        
      const blogContainer = document.querySelector('slider-component .blog__posts'); 
      if (!blogContainer) {
        console.error('Not exist .blog-articles in the DOM.');
        return;
      } 

      blogContainer.innerHTML = '';

      data.results.forEach((post, index) => {
        if (!post.featuredImage || !post.name || !post.url) {
          console.warn('Not properties post:', post);
          return;
        }

        const { featuredImage, name, url, metaDescription } = post;

        const blogItem = document.createElement('li');
        blogItem.className = 'blog__post grid__item article slider__slide slider__slide--full-width scroll-trigger animate--slide-i';

        // Mantengo tu bloque original aquí
        blogItem.innerHTML = `
        <div class="article-card-wrapper card-wrapper" data-index="${index}">
            
            <div class="
                card article-card
                card--card
                 card--media
              " style="--ratio-percent: 60.24096385542169%;">
              <div class="card__inner  ratio" style="--ratio-percent: 60.24096385542169%;"><div class="article-card__image-wrapper card__media">
                    <div class="article-card__image media media--hover-effect">
                      
                      <img   src="${featuredImage}" sizes="(min-width: 1600px) 750px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)" 
                      alt="${name}" class="motion-reduce" loading="lazy" width="3677" height="2456">
                      
                    </div>
                  </div><div class="card__content">
                  <div class="card__information">
                    <h3 class="card__heading h2">
                      <a href="${url}" target="_blank"  class="full-unstyled-link">
                        ${name}...
                      </a>
                    </h3>
                    <div class="article-card__info caption-with-letter-spacing h5"></div>
                    <p class="article-card__excerpt rte-width">${metaDescription}....
        </p><div class="article-card__footer"><a href="${url}" target="_blank">READ MORE</a>
                      </div></div></div>
              </div>
              <div class="card__content">
                <div class="card__information">
                <div class="card__description-box>
                   <h3 class="card__heading h2">
                    <a href="${url}" target="_blank" class="full-unstyled-link">
                      ${name}...
                    </a>
                  </h3>
             
  
                  <p class="article-card__excerpt rte-width">${metaDescription}....</p>       
                     </div> 
                    <div  class="article-card__footer">
                        <a class="button button--secondary" href="${url}" target="_blank">
                        READ MORE
                        </a>
                    </div>
                 
            </div>
          </div>
            
                
              `;

        blogContainer.appendChild(blogItem);
      });

      attachSliderScrollListener(blogContainer); // Conectamos el listener al slider
    })
    .catch((error) => console.error('Error fetching blog posts:', error));
}

function attachSliderScrollListener(blogContainer) {
  const slider = document.querySelector('[id^="SliderHome-"]');
  const currentPageElement = document.querySelector('slider-component.slider-home .slider-buttons .slider-counter--current');
  const totalPageElement = document.querySelector('slider-component.slider-home .slider-buttons .slider-counter--total');

  if (!slider || !currentPageElement || !totalPageElement) {
    console.error("Slider or page elements not found.");
    return;
  } 

  const sliderItemWidth = slider.querySelector('.slider__slide').offsetWidth; // Ancho de un elemento del slider
  totalPageElement.textContent = limit; // Total de páginas basado en la API (opcional)

  slider.addEventListener('scroll', () => {
    const currentPage = Math.round(slider.scrollLeft / sliderItemWidth) + 1;
    currentPageElement.textContent = currentPage;
    console.log('Current page:', currentPage);
  });
}

// Inicializamos la carga de los posts
loadBlogPosts(Page);
